import React from 'react';
import { useNavigate } from 'react-router-dom';
import Vista from './layout/Vista';
import ReferentiFilterBar from './referenti/FilterBar';
import ReferentiListRow from './referenti/ListRow';
import { ReactComponent as IconAdd } from '../assets/icons/plus.svg';

export default function Referenti({ initialSearchterm = '' }) {
    const navigate = useNavigate();

    const actions = [
        {
            label: "Crea nuova",
            icon: <IconAdd/>,
            onClick: () => navigate('/referente'),
            className: "add-btn"
        }
    ];

    return (
        <Vista
            apiCallEndpoint={"/listareferenti"}
            initialFilterParams={{ searchterm: initialSearchterm }}
            FilterBarComponent={ReferentiFilterBar}
            ListRowComponent={ReferentiListRow}
            actions={actions}
            endMessage="Non ci sono altri referenti"
        />
    );
}